module.exports = __webpack_public_path__ + "media/images/calendar_on-e42730c4380273470db1590a5a5ed5f3.png";